export const reviews = [
  { id: "petra", rating: 5, source: "google" },
  { id: "lotti", rating: 5, source: "google" },
  { id: "matyas", rating: 5, source: "google" },
  { id: "daffodils", rating: 5, source: "google" },
  { id: "peter", rating: 5, source: "google" },
  { id: "es8", rating: 5, source: "google" },
  { id: "lajos", rating: 5, source: "google" },
  { id: "hanna", rating: 5, source: "google" },
  { id: "bence", rating: 5, source: "google" },
  { id: "lucky", rating: 5, source: "google" },
];
